import React from "react";

export default function NextOfKin({ data, onChange }) {
  const handleInputChange = (key, value) => {
    onChange({
      ...data,
      [key]: value,
    });
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Next of Kin Information</h2>
      <div className="grid grid-cols-2 gap-6">
        {/* Emergency Contact Name */}
        <div>
          <label className="block mb-1">Emergency Contact Name</label>
          <input
            type="text"
            value={data?.emergency_contact_name || ""}
            onChange={(e) =>
              handleInputChange("emergency_contact_name", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Name"
          />
        </div>

        {/* Emergency Contact Relationship */}
        <div>
          <label className="block mb-1">Relationship</label>
          <input
            type="text"
            value={data?.emergency_contact_relation || ""}
            onChange={(e) =>
              handleInputChange("emergency_contact_relation", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Relationship"
          />
        </div>

        {/* Emergency Contact Number */}
        <div>
          <label className="block mb-1">Contact Number</label>
          <input
            type="text"
            value={data?.emergency_contact_no || ""}
            onChange={(e) =>
              handleInputChange("emergency_contact_no", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Contact Number"
          />
        </div>
      </div>
    </div>
  );
}
